exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".labelize .btn-group .close-btn{margin-left:20px}.label-obs-item{margin-bottom:5px;margin-left:2px;margin-right:2px;padding:2px}.label-obs-item:not(.selected){cursor:pointer}.label-obs-item.selected{border-radius:5px;border:2px solid #ea705a}.trigger-i{border:1px solid #fff;padding:2px}", ""]);

